import moment from 'moment';
import { BusinessCentralTestStatus, IBusinessCentralStatus, IBusinessCentralSync } from '../shared-services/business-central/business-central.model';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

/** The connection's chip: linked and reachable, linked but a step is missing, or not set up. */
export const connectionChip = (status: IBusinessCentralStatus): { label: string, color: ChipColor } => {
  if (!status.connected) return { label: 'Not set up', color: 'default' };
  const lastTest = status.connection?.lastTest;
  if (lastTest && lastTest.status !== 'connected') return { label: 'Needs attention', color: 'warning' };
  return { label: 'Connected', color: 'success' };
};

export const TEST_STATUS_LABELS: Record<BusinessCentralTestStatus, string> = {
  'connected': 'Business Central can be read',
  'consent-missing': 'Access has not been granted in Microsoft yet',
  'business-central-step': 'The application is not allowed in Business Central yet',
  'environment-not-found': 'The environment was not found',
  'error': 'Business Central could not be reached',
};

export const syncChip = (sync: IBusinessCentralSync | undefined): { label: string, color: ChipColor } => {
  if (!sync) return { label: 'Not synced yet', color: 'default' };
  if (sync.truncated) return { label: 'Partly synced', color: 'warning' };
  return { label: 'Synced', color: 'success' };
};

export const formatDateTime = (value: string | null | undefined): string =>
  value ? moment(value).format('D MMM YYYY, HH:mm') : '';

/** "14 Oct 2026, 09:40: 40 read, 7 new" style summary of a sync. */
export const describeSync = (sync: IBusinessCentralSync): string => {
  const parts = [`${sync.fetchedCount} read`, `${sync.importedCount} new`];
  if (sync.stagedExcludedCount > 0) parts.push(`${sync.stagedExcludedCount} excluded`);
  return `${formatDateTime(sync.syncedAt)}: ${parts.join(', ')}${sync.truncated ? '. Sync again for the rest' : ''}`;
};
